// Static HTML site (PacWest Digital) is served directly from /public.
// React renders nothing — the #root div is hidden in index.html.
function App() {
  return null;
}

export default App;
